<script>
    import Track from "./Track.svelte"
    import { doc } from "../util/stores.js"

    export let removeTrack

    let tracks;
    doc.subscribe(value => {
        tracks = value['boards']['Plot']
        //console.log(tracks)
    })

</script>

{#each tracks as track, i}
    <Track width='100%' track_index={i} modules={track['modules']} removable={false} page='Plot'></Track>
{/each}

<style lang="scss">
    @use "styles/global.scss";

    
</style>